// extracted by mini-css-extract-plugin
export default {"Range":"Range_Range__Hb1Mi","photoCrop":"Range_photoCrop__rdQWa"};